module.exports = __webpack_public_path__ + "static/media/call.55263abd.svg";